import { useState, useEffect } from 'react'
import {
  getLectureSettings,
  saveLectureSettings,
  resetLectureSettings,
  DEFAULT_LECTURE_SETTINGS,
} from '../api/settingsApi'
import { appToast } from '../../../../components/AppToast'

export default function useLectureSettings() {
  const [settings, setSettings] = useState(DEFAULT_LECTURE_SETTINGS)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    let isMounted = true
    getLectureSettings().then((loaded) => {
      if (isMounted && loaded) {
        setSettings(loaded)
      }
    })
    return () => {
      isMounted = false
    }
  }, [])

  const setField = (field, value) => {
    setSettings((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const toggleSmsTo = (key) => {
    setSettings((prev) => ({
      ...prev,
      smsTo: {
        ...prev.smsTo,
        [key]: !prev.smsTo[key],
      },
    }))
  }

  const toggleWhatsAppTo = (key) => {
    setSettings((prev) => ({
      ...prev,
      whatsAppTo: {
        ...prev.whatsAppTo,
        [key]: !prev.whatsAppTo[key],
      },
    }))
  }

  const handleSave = async () => {
    setIsSaving(true)
    try {
      const res = await saveLectureSettings(settings)
      if (res.success) {
        if (res.settings) setSettings(res.settings)
        appToast.success('Lecture settings saved successfully!')
      } else {
        appToast.error(res.error || 'Failed to save lecture settings.')
      }
    } finally {
      setIsSaving(false)
    }
  }

  const handleReset = async () => {
    setIsSaving(true)
    try {
      const res = await resetLectureSettings()
      if (res.success) {
        setSettings(res.settings)
        appToast.info('Settings reset to system defaults.')
      } else {
        appToast.error(res.error || 'Failed to reset lecture settings.')
      }
    } finally {
      setIsSaving(false)
    }
  }

  return {
    settings,
    isSaving,
    setField,
    toggleSmsTo,
    toggleWhatsAppTo,
    handleSave,
    handleReset,
  }
}
